module.exports = __webpack_public_path__ + "static/00-6969ec20495afc391c29fe4c22c9e1d3.png";